<template>
  <div class="list">
    <div class="nwrap">
      <div class="nei_ban">
        <img :src="indexImg" style="width: 100%; height: 100%" />
        <h3>{{slideHdName}}<p></p></h3>
      </div>
      <div class="clear ptb3"></div>
      <div class="mainbox wrap">
        <div class="news_l">
          <ul class="news_cl">
            <li v-for="(item, index) in slideList" :key="index" :class="{on : active  == item.entTChannelUuid}">
              <a
                v-if="item.url && item.url !== ''" 
                :href="item.url">
                {{item.name}}
              </a>
              <a 
                v-if="(!item.url || item.url == '') && item.entTChannelUuid != '02010001'" 
                :href="item.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog === 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                {{item.name}}
              </a>
              <a 
                v-if="item.entTChannelUuid == '02010001'" 
                :href="`/culture`">
                {{ item.name }}
              </a>
            </li>
          </ul>
          <div class="clear"></div>
          <div class="nw_list">
            <dl v-for="(item,index) in listData" :key="index">
              <a v-if="item.url && item.url !== ''" :href="item.url">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3>
                    {{item.title }}
                  </h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD HH:mm') }}</h5>
                  <p>{{ item.artDesc}}</p>
                </dd>
              </a>
              <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3>
                    {{item.title }}
                  </h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD HH:mm') }}</h5>
                  <p>{{ item.artDesc}}</p>
                </dd>
              </a>
              <div class="clear"></div>
            </dl>
          </div>
          <div class="listpagination" v-if="listData.length!=0">
            <el-pagination 
              layout="prev, pager, next" 
              :current-page="pageNum" 
              :page-size="pageSize" 
              :total="total" 
              :pager-count="7" 
              @current-change="currentChange" 
            >
            </el-pagination>
          </div>
        </div>
        <div class="news_r news_line">
          <div class="news_tjtit">{{$t('m.topNews')}}</div>
          <div class="nw_tj_list" v-if="$i18n.locale == 'zh-CN'">
            <dl v-for="(item,index) in newslist" :key="index">
              <a v-if="item.url && item.url !== ''" :href="item.url">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3>
                    {{item.title }}
                  </h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</h5>
                </dd>
              </a>
              <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3>
                    {{item.title }}
                  </h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</h5>
                </dd>
              </a>
              <div class="clear"></div>
            </dl>
            <div class="clear pt10"></div>
          </div>
          <div class="nw_tj_list" v-if="$i18n.locale == 'en-US'">
            <dl v-for="(item,index) in newslistEn" :key="index">
              <a v-if="item.url && item.url !== ''" :href="item.url">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3>
                    {{item.title }}
                  </h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</h5>
                </dd>
              </a>
              <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                <dt>
                  <img v-if="item.thumb1 && item.thumb1!= '' " :src="item.thumb1">
                  <img v-else src="../assets/image/16566653257874.jpeg">
                </dt>
                <dd>
                  <h3>
                    {{item.title }}
                  </h3>
                  <h5>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</h5>
                </dd>
              </a>
              <div class="clear"></div>
            </dl>
            <div class="clear pt10"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import { getChildChannel, getChannelInfo, articles,getAllArtListByParentUuid ,getCookie } from '@/api/common'

export default {
  name: 'list',
  data(){
    return {
      indexImg: '',
      slideHdTitle: '',
      viewSlideHdParent: true,
      slideHdParentName: '',
      slideHdParentUrl: '',
      slideHdName: '',
      hdTitle: '',
      hdName: '',
      pageCont: '',
      active: '',
      slideHd: {
        title: '新闻动态',
      },
      slideList:[],
      pageSize: 6,
      pageNum: 1,
      total: 0,
      listData: [],
      newslist: [],
      newslistEn: [],
      entTApplicationUuid: '',
      listId: '',
      applicationUuid:'',
      lang: 'zh-CN',
    }
  },
  mounted(){
    var _this = this
    _this.active = _this.$route.params.id
    _this.listId = _this.$route.params.id

    let lang = getCookie('lang')
    if( lang == 'en-US'){
      this.applicationUuid = this.webIdEn
    }
    else {
      this.applicationUuid = this.webId
    }

    // _this.getChildChannel()
    _this.getChannelInfo()
    _this.articles()
  },
  methods: {
    // 查询二级栏目
      getChildChannel(id) {
        var _this = this
        let data = {
          applicationUuid: this.applicationUuid,
          parentUuid: id
        }
        getChildChannel(data).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            _this.slideList = data
            if (_this.slideList.length) {
              _this.viewSlideHdParent = true
              let url = ''
              if (_this.slideList[0].catalog === 1) {
                url = `/listPage/${_this.slideList[0].entTChannelUuid}`
              } else if (_this.slideList[0].catalog === 2) {
                url = `/list/${_this.slideList[0].entTChannelUuid}`
              } else {
                url = `/list/${_this.slideList[0].entTChannelUuid}`
              }
              _this.slideHdParentUrl = url
            } else {
              _this.viewSlideHdParent = false
            }
          }
        })
      },
      getChannelInfo() {
        var _this = this
        let data = {
          channelUuid: _this.$route.params.id
        }
        getChannelInfo(data).then(res => {
          const { code, data } = res
          if (code === 1 && data) {
            _this.slideHdName = data.name
            if (data.parentUuid == "0") {
              _this.slideHdTitle = data.name
              _this.getChildChannel(data.entTChannelUuid)
              _this.viewSlideHdParent = false
              if(data.fileName && data.fileName !== ''){
                _this.indexImg = data.fileName
              }
              else{
                _this.indexImg = require('../assets/image/partyBuilding.jpg')
              }
              return
            }

            _this.getChildChannel(data.parentUuid)

            let params = {
              channelUuid: data.parentUuid
            }
            getChannelInfo(params).then(res => {
              const { code, data } = res
              if (code === 1 && data) {
                _this.slideHdParentName = data.name
                _this.slideHdTitle = data.name
                if(data.fileName && data.fileName !== ''){
                  _this.indexImg = data.fileName
                }
                else{
                  _this.indexImg = require('../assets/image/partyBuilding.jpg')
                }
              }
            })
          }
        })
      },
      articles() {
        var _this = this
        let data = {
          entTApplicationUuid: this.applicationUuid,
          channelUuid : _this.listId,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
        if( _this.$route.params.id=="0199" || _this.$route.params.id=="0200" || _this.$route.params.id=="0208"){
          getAllArtListByParentUuid(data).then(res => {
            const {
              code,
              data
            } = res
            if (code === 1 && data) {
              _this.listData = data.rows
              _this.total = data.totalRows
            }
          })
        }
        else{
          articles(data).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            _this.listData = data.rows
            _this.total = data.totalRows
          }
        })
        }

        let data2 = {
          entTApplicationUuid: _this.webId,
          channelUuid : '01990001',
          pageNum: 1,
          pageSize: 4
        }
        articles(data2).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            _this.newslist = data.rows
          }
          
        })

        let data4 = {
          entTApplicationUuid: _this.webIdEn,
          channelUuid : '02080001',
          pageNum: 1,
          pageSize: 4
        }
        articles(data4).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            _this.newslistEn = data.rows
          }
        })

      },
      currentChange(e) {
        var _this = this
        _this.pageNum = e
        _this.articles()
      }
    }
  }
</script>

<style scoped>
.list .nei_ban {
  clear: both;
  width: 100%;
  height: 270px;
}
.list .nei_ban h3 {
  text-align: center;
  width: 100%;
  clear: both;
  font-size: 48px;
  color: #fff;
  font-weight: normal;
  margin-top: -175px;
}
.list .nei_ban p {
  font-size: 24px;
  color: #fff;
  text-transform: uppercase;
}
.list .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.list .ptb3 {
  padding-top: 3%;
}
.list .wrap {
  width: 1200px;
  margin: 0 auto;
}
.list .news_l {
  float: left;
  width: 68%;
}
.list .news_cl {
  clear: both;
  width: 100%;
}
.list .nw_list {
  clear: both;
  width: 100%;
}
.list .nw_list dl {
  clear: both;
  border-bottom: 1px #dcdcdc solid;
  padding: 30px 0;
}
.list .nw_list dl dt {
  float: left;
  width: 25%;
}
.list .nw_list dl dt img {
  width: 100%;
  height: 100%;
}
.list img {
  max-width: 100%;
}
.list .nw_list dl dd {
  float: right;
  width: 71%;
}
.list .nw_list dl dd h3 {
  font-size: 18px;
}
.list .nw_list dl dd h5 {
  font-weight: normal;
  font-size: 12px;
  color: #999999;
  padding: 10px 0;
}
.list .nw_list dl dd p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 26px;
}
.list .news_cl li {
  float: left;
  padding-right: 20px;
}
.list .news_cl li a {
  font-size: 22px;
}
.list .news_cl li.on a {
  color: #0ba299;
}
.list .listpagination{
margin: 20px auto;
text-align: center;
}
.list .news_line {
  border-left: 1px #dcdcdc solid;
}
.list .news_r {
  float: right;
  width: 28%;
  padding-left: 35px;
  box-sizing: border-box;
}
.list .news_tjtit {
  font-size: 22px;
  padding-bottom: 18px;
}
.list .nw_tj_list {
  clear: both;
  width: 100%;
}
.list .nw_tj_list dl {
  clear: both;
  padding: 12px 0;
}
.list .nw_tj_list dl dt {
  float: left;
  width: 35%;
}
.list .nw_tj_list dl dt img {
  width: 100%;
  height: 100%;
}
.list img {
  max-width: 100%;
}
.list .nw_tj_list dl dd {
  float: right;
  width: 60%;
}
.list .nw_tj_list dl dd h3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.list .nw_tj_list dl dd h5 {
  font-weight: normal;
  font-size: 12px;
  color: #999999;
  padding-top: 3px;
}
@media (max-width: 1400px) {
.list .wrap {
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px;
}
}
@media (max-width: 768px) {
.list .wrap {
  box-sizing: border-box;
  width: 100%;
  padding: 0 15px;
}
.list .news_l {
  width: 100%;
}
.list .news_cl li a {
  font-size: 18px;
}
.list .nw_list dl dt {
  width: 35%;
}
.list .nw_list dl dd h3 {
  font-size: 14px;
}
.list .nw_list dl dd {
  width: 60%;
}
.list .nw_list dl dd p {
  display: none;
}
.list .news_r {
  width: 100%;
  padding: 0;
  border-left: none;
  margin-bottom: 20px;
}

}
</style>